import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateOrderReportComponent } from './create-order-report.component';

const routes: Routes = [
  {
    path: '',
    component: CreateOrderReportComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreateOrderReportRoutingModule { }
